import React, { useState, useContext, useEffect, forwardRef, useImperativeHandle } from "react";
import { LocationContext } from "../services/LocationContext";
import logger from "../services/Logger";

const AddressCheckboxList = forwardRef(({ items, checkboxChange }, ref) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const { getLocationCommuteResultValue } = useContext(LocationContext);

  useEffect(() => {
    logger.info("This is the checked items - ", checkedItems);
    checkboxChange && checkboxChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedItems]);

  useEffect(() => {
    const checkedElements = [];
    items.forEach((element) => {
      const locationCommute = getLocationCommuteResultValue(element.locationAddress);
      // TODO - change the object to include the commute result and style as a property

      if (locationCommute) {
        if (locationCommute.text === "I") {
          checkedElements.push(element.locationAddress);
        }
      }
    });
    setCheckedItems(checkedElements);
    setIsLoaded(true);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  useImperativeHandle(ref, () => ({
    getCheckedAddresses,
  }));

  const getCheckedAddresses = () => {
    return checkedItems;
  };

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setCheckedItems([...checkedItems, value]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== value));
    }
    logger.info("Checkbox changed - ", value, isChecked, checkboxChange);
  };

  const getStylePerLocation = (location) => {
    const locationCommute = getLocationCommuteResultValue(location.locationAddress);
    if (locationCommute) {
      return { backgroundColor: locationCommute.color };
    }
  };

  return (
    <div>
      {isLoaded ? (
        <ul>
          {items
            .filter((item) => !item.isConstraint)
            .map((item) => (
              <li key={item.locationAddress}>
                <label style={getStylePerLocation(item)}>
                  <input type="checkbox" value={item.locationAddress} checked={checkedItems.includes(item.locationAddress)} onChange={handleCheckboxChange} />
                  {item.locationAddress}
                </label>
              </li>
            ))}
        </ul>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
});

export default AddressCheckboxList;
